(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sava-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  let adding = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  function syncAgreement() {
    const hasItems = Boolean(document.querySelector('cart-drawer .cart-item, #main-cart-items .cart-item'));
    document.querySelectorAll('[data-sava-checkout]').forEach(button => { button.disabled = !hasItems || adding; });
  }
  function sectionTargets() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) return ['cart-drawer', 'cart-icon-bubble'];
    return [document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id, 'cart-icon-bubble'].filter(Boolean);
  }
  function renderCart(sections, opener) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer'] && sections['cart-icon-bubble']) {
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(opener);
      drawer.renderContents({ sections });
    } else if (!drawer) {
      ['main-cart-items','main-cart-footer','cart-icon-bubble'].forEach(id => {
        const current = document.getElementById(id);
        const key = current?.dataset.id || id;
        if (!current || !sections[key]) return;
        const replacement = parse(sections[key]).getElementById(id);
        if (replacement) current.replaceWith(replacement);
      });
    } else {
      window.location.assign(root() + 'cart');
    }
    watchAgreement();
    syncAgreement();
  }
  class SavaQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const panel = this.panel = this.querySelector('.sava-qa__panel');
      this.status = this.querySelector('.sava-qa__status');
      if (panel.tagName === 'DIALOG') {
        panel.append(this.status);
        panel.classList.add('sava-qa');
        document.body.append(panel);
        panel.addEventListener('cancel', () => this.close(), options);
      }
      const onClick = event => {
        if (event.target.closest('[data-picker-close]')) { this.close(); if (event.detail === 0) this.querySelector('.sava-qa__toggle').focus({ preventScroll:true }); return; }
        const toggle = event.target.closest('.sava-qa__toggle');
        if (toggle) {
          event.preventDefault();
          const panel = this.panel;
          const opening = panel.hidden;
          document.querySelectorAll('sava-quick-add').forEach(picker => { if (picker !== this) picker.close(); });
          const direct = panel.querySelector('.sava-qa__add[data-variant-id]:not([data-preorder-submit]):not([data-multi-add])');
          if (direct && !adding) { this.add(direct, toggle); return; }
          panel.hidden = !opening;
          if (panel.tagName === 'DIALOG') {
            if (opening) {
              if (typeof panel.showModal === 'function') panel.showModal();
              else { panel.setAttribute('open', ''); panel.classList.add('sava-qa__dialog--fallback'); }
            } else this.close();
          }
          toggle.setAttribute('aria-expanded', String(opening));
          if (opening && panel.tagName !== 'DIALOG' && event.detail === 0) panel.querySelector('button:not(:disabled),select')?.focus({ preventScroll:true });
          return;
        }
        const preSize = event.target.closest('[data-preorder-variant]');
        if (preSize && !adding) {
          const confirm = this.panel.querySelector('[data-preorder-confirm]');
          const submit = confirm.querySelector('[data-preorder-submit]');
          submit.dataset.variantId = preSize.dataset.preorderVariant;
          submit.dataset.preorderPolicy = preSize.dataset.preorderPolicy;
          confirm.hidden = false;
          this.panel.querySelectorAll('[data-preorder-variant]').forEach(el => el.setAttribute('aria-pressed', String(el === preSize)));
          if (event.detail === 0) submit.focus({ preventScroll:true }); return;
        }
        const button = event.target.closest('[data-variant-id]');
        if (button && !button.disabled) { event.preventDefault(); this.add(button, this.querySelector('.sava-qa__toggle')); }
      };
      this.addEventListener('click', onClick, options);
      if (panel.tagName === 'DIALOG') panel.addEventListener('click', event => { event.stopPropagation(); onClick(event); }, options);
      const onChange = () => this.updateOptions();
      this.addEventListener('change', onChange, options);
      if (panel.tagName === 'DIALOG') panel.addEventListener('change', onChange, options);
      const onKey = event => { if (event.key === 'Escape') { this.close(); this.querySelector('.sava-qa__toggle').focus({ preventScroll:true }); event.stopPropagation(); } };
      this.addEventListener('keydown', onKey, options);
      if (panel.tagName === 'DIALOG') panel.addEventListener('keydown', onKey, options);
    }
    disconnectedCallback() { this.close(); if (this.panel?.tagName === 'DIALOG') { this.append(this.panel); this.panel.classList.remove('sava-qa'); } this.abort?.abort(); this.abort = null; }
    close() { const panel = this.panel; if (panel) { if (panel.tagName === 'DIALOG' && panel.open) { if (typeof panel.close === 'function') panel.close(); else panel.removeAttribute('open'); } panel.hidden = true; } this.querySelector('.sava-qa__toggle')?.setAttribute('aria-expanded','false'); }
    updateOptions() {
      const json = this.panel.querySelector('[data-variants]');
      if (!json) return;
      const variants = JSON.parse(json.textContent);
      const selects = Array.from(this.panel.querySelectorAll('select'));
      const chosen = selects.map(select => select.value);
      selects.forEach((select,index) => Array.from(select.options).forEach(option => {
        if (!option.value) return;
        option.disabled = !variants.some(variant => variant.available && variant.options[index] === option.value && chosen.every((value,i) => i >= index || !value || variant.options[i] === value));
      }));
      const variant = variants.find(v => v.available && v.options.every((value,index) => value === chosen[index]));
      const button = this.panel.querySelector('[data-multi-add]');
      const preorders = JSON.parse(this.panel.querySelector('[data-preorder-ids]')?.textContent || '[]');
      const isPreorder = !!variant && preorders.includes(variant.id);
      button.toggleAttribute('data-preorder-submit', isPreorder);
      button.dataset.preorderPolicy = isPreorder ? 'continue' : '';
      button.textContent = isPreorder ? this.dataset.preorderButton : this.dataset.add;
      this.panel.querySelector('[data-multi-preorder-notice]').hidden = !isPreorder;
      button.disabled = !variant;
      if (variant) button.dataset.variantId = variant.id;
      else delete button.dataset.variantId;
    }
    async add(button, opener) {
      if (adding || !button.dataset.variantId) return;
      if (button.disabled) return;
      const requestedVariantId = String(button.dataset.variantId);
      adding = true;
      syncAgreement();
      const status = this.status;
      status.hidden = false; status.textContent = this.dataset.adding;
      this.setAttribute('aria-busy','true');
      const buttons = Array.from(this.panel.querySelectorAll('button, select')).map(el => [el,el.disabled]);
      buttons.forEach(([el]) => { el.disabled = true; });
      let added = false;
      try {
        if (!window.SavaPreorder) throw new Error('Please refresh and try again.');
        const state = await window.SavaPreorder.validate(this.dataset.productUrl, requestedVariantId);
        if (String(button.dataset.variantId) !== requestedVariantId) throw new Error('Your selection changed. Please try again.');
        if (!state.available) throw new Error('This size is sold out. Please choose another size.');
        button.toggleAttribute('data-preorder-submit', state.preorder);
        button.dataset.preorderPolicy = state.policy;
        if (button.classList.contains('sava-qa__add')) button.textContent = state.preorder ? this.dataset.preorderButton : this.dataset.add;
        const notice = this.panel.querySelector('[data-multi-preorder-notice]');
        if (notice) notice.hidden = !state.preorder;
        const keys = sectionTargets();
        const response = await fetch(root() + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ items:[{id:requestedVariantId,quantity:1,properties:window.SavaPreorder.properties(state)}], sections:keys, sections_url:window.location.pathname }) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
        added = true;
        let sections = data.sections;
        if (!sections || keys.some(key => !sections[key])) {
          const refresh = await fetch(root() + '?sections=' + encodeURIComponent(keys.join(',')));
          sections = await refresh.json();
        }
        this.close(); status.hidden = true;
        renderCart(sections, opener);
      } catch (error) {
        if (added) window.location.assign(root() + 'cart');
        else { status.hidden = false; status.textContent = error.message || this.dataset.error; }
      } finally {
        adding = false;
        this.removeAttribute('aria-busy');
        buttons.forEach(([el,disabled]) => { el.disabled = disabled; });
        syncAgreement();
      }
    }
  }
  class SavaProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const track = this.querySelector('.sava-gallery__track');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-image-index]');
        if (button) track.scrollTo({ left:track.clientWidth * Number(button.dataset.imageIndex), behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      }, { signal:this.abort.signal });
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        this.querySelectorAll('[data-image-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.imageIndex) === index)));
      }, { passive:true, signal:this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  if (!customElements.get('sava-quick-add')) customElements.define('sava-quick-add', SavaQuickAdd);
  if (!customElements.get('sava-product-gallery')) customElements.define('sava-product-gallery', SavaProductGallery);
  document.addEventListener('click', event => {
    if (!event.target.closest('sava-quick-add, .sava-qa__dialog')) document.querySelectorAll('sava-quick-add').forEach(picker => picker.close());
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('#cart,#CartDrawer-Form')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (adding) event.preventDefault();
  }, true);
  const watched = new WeakSet();
  function watchAgreement() {
    document.querySelectorAll('#CartDrawer,#main-cart-footer').forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      new MutationObserver(syncAgreement).observe(element,{childList:true,subtree:true});
    });
  }
  function boot() { watchAgreement(); syncAgreement(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
